import { render, staticRenderFns } from "./install.vue?vue&type=template&id=8effa896&scoped=true&"
import script from "./install.vue?vue&type=script&lang=js&"
export * from "./install.vue?vue&type=script&lang=js&"
import style0 from "./install.vue?vue&type=style&index=0&id=8effa896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8effa896",
  null
  
)

export default component.exports